import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import LoanRequestFormPdf from "./ArrivalOnbordingPdf/LoanRequestFormPdf";

const DummyPdfs = () => {
  return (
    <>
      <PDFViewer className="w-full min-h-screen">
        <LoanRequestFormPdf />
      </PDFViewer>
    </>
  );
};

export default DummyPdfs;
